import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {AiUsageSection} from '.';

type Props = {
    isEnabled: boolean;
    setIsEnabled: (isEnabled: boolean) => void;
    limit: number | null | undefined;
    remaining: number | null | undefined;
};

export function AiSummarizationSection(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body isBold={true} color='dark' size='large'>
                Transcripts and summarizations
            </Body>
            <AiUsageSection
                setIsEnabled={props.setIsEnabled}
                isEnabled={props.isEnabled}
                description='Allow Nutshell users to request summaries of timelines and transcripts.'
                title='Summarization usage'
                link='https://support.nutshell.com/en/articles/8428988-data-privacy-nutshell-ai-summarization-tool'
                limit={props.limit}
                remaining={props.remaining}
                unit={props.remaining === 1 ? 'summarization' : 'summarizations'}
            />
        </StackLegacy>
    );
}
